import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Eye = styled.svg`
  width: 22px;
  height: 13px;
  color: var(--cvna-color-blue-2);
  fill: var(--cvna-color-blue-2);
  &:hover {
    color: var(--cvna-color-blue-3);
    fill: var(--cvna-color-blue-3);
  }
`;

type OwnProps = React.SVGProps<SVGSVGElement>;

const EyeIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Eye viewBox="0 0 22 13" ref={ref} {...props}>
    <path d="M11,0C4,0,0,5.11,0,6.5S4,13,11,13,22,7.89,22,6.5,18,0,11,0ZM5.82,10.07a9.58,9.58,0,0,1-4-3.57,9.58,9.58,0,0,1,4-3.57,5.95,5.95,0,0,0,0,7.14Zm5.18.85A4.53,4.53,0,0,1,6.38,6.5,4.53,4.53,0,0,1,11,2.08,4.53,4.53,0,0,1,15.61,6.5,4.52,4.52,0,0,1,11,10.92Zm5.18-.85a6,6,0,0,0,0-7.14,9.72,9.72,0,0,1,4,3.57A9.72,9.72,0,0,1,16.18,10.07ZM11,4.66A1.88,1.88,0,0,0,9.09,6.5a1.91,1.91,0,0,0,3.81,0A1.87,1.87,0,0,0,11,4.66Z" />
  </Eye>
));

export default EyeIcon;
